import UsersList from 'components/UsersList/component';

export default UsersList;
